import React from 'react';
import { MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { clearCachedThemes } from '../api/fetchUserThemes';

interface SettingsMenuItemProps {
  handleMenuClose: () => void;
  from: string;
  saveAndNavigateTo?: (path: string) => void;
  navigateToPath: string;
}

const SettingsMenuItem: React.FC<SettingsMenuItemProps> = ({
  handleMenuClose,
  from,
  saveAndNavigateTo,
  navigateToPath,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    handleMenuClose();
    clearCachedThemes();
    if (from === 'dataViewer' && typeof saveAndNavigateTo === 'function') {
      saveAndNavigateTo(navigateToPath);
    } else {
      
      navigate('/settings');
    }
  };

  return (
    <MenuItem onClick={handleClick} style={{ height: '35px' }}>
      <div
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <img
          src="/settings.png"
          alt="Settings"
          style={{
            marginRight: '5px',
            width: '20px',
            height: '20px',
          }}
        />
        <span>Settings</span>
      </div>
    </MenuItem>
  );
};

export default SettingsMenuItem;
